<template>
    <section class="sub_page_con wrap_1120 report_area">
        <div class="btn_wrap _default right_btn _adm_btn">
            <button class="common_btn" @click="openGuideModal" v-if="state.hasAuth && !state.isMobile">안내글 수정하기</button>
        </div>
        <div class="sub_con_banner">
            <div v-html="CommonUtils.decodeContent(state.menuContent)"></div>
            <div class="link con_list">
                <p>시민제보 처리과정이 궁금하신가요? </p>
                <a href="#faqView/27" class="action_btn" target="_blank">
                    <span>과정 보러가기</span>
                    <img src="img/move_btn.png" alt="" />
                </a>
            </div>
        </div>

        <div class="btn_wrap _default float_right _board_type in_line">
            <button class="common_btn" @click="router.push('/areaWrite')" v-if="!state.hasAuth">제보하기</button>
        </div>
        <div class="btn_wrap _default float_right _board_type in_line" v-if="state.hasAuth">
            <button class="common_btn _gray" type="button" @click="isDelete">삭제</button>
            <button class="icon_wrap" type="button" @click="downloadFile" v-if="!state.isMobile">
                <img src="img/excel_icon.png" alt="엑셀 다운로드" />
            </button>
        </div>

        <div class="select_tab_box _board_type">
            <div class="selected_tab" :class="[state.isShowSearchType ? 'active' : '']" @click="state.isShowSearchType = !state.isShowSearchType">
                <span>{{ state.detailTxt }}</span>
            </div>
            <div class="tab_option">
                <button
                    v-for="item in search_type_list"
                    @click="
                        state.detailType = item.key;
                        state.detailTxt = item.value;
                        state.isShowSearchType = false;
                        getList();
                    "
                >
                    {{ item.value }}
                </button>
            </div>
        </div>

        <div class="list_table con_board sub_page_con_view areaList">
            <ul>
                <li class="thead_li">
                    <div class="tr_div con_tit">
                        <div class="tb_chk checkbox_wrap2" v-if="state.hasAuth">
                            <input type="checkbox" v-model="state.checkAll" @change="toggleAll()" />
                            <em></em>
                        </div>
                        <div class="tb_no no_768">번호</div>
                        <div class="tb_ans">상태</div>
                        <div class="tb_subject">제목</div>
                        <div class="tb_part">분류</div>
                        <!-- <div class="tb_wr_name">닉네임</div> -->
                        <div class="tb_date_hour">날짜</div>
                    </div>
                </li>

                <li class="tbody_li" v-for="(item, idx) in state.list" :key="item.idx">
                    <div class="tr_div con_tit">
                        <div class="tb_chk checkbox_wrap2" v-if="state.hasAuth" @click.stop>
                            <input type="checkbox" v-model="state.checkedList" :value="item.idx" @click.stop />
                        </div>
                        <div class="tb_no no_768">{{ (state.page - 1) * state.size + (idx + 1) }}</div>
                        <div :class="state.hasAuth ? 'tb_ans adm_login' : 'tb_ans'">
                            <span :class="[item.state === 1 ? 'ans_yet' : 'ans_complete']">{{ item.state === 1 ? "대기중" : "접수완료" }}</span>
                        </div>
                        <div class="tb_subject">
                            <router-link :to="{ name: 'AreaView', params: { id: item.idx } }" class="elips_1">성매매 의심업소 제보</router-link>
                        </div>
                        <template v-if="!state.isMobile">
                            <div class="tb_part">{{ item.isSchool === 1 ? "학교주변" : "의심업소" }}</div>
                            <!-- <div class="tb_wr_name">{{ item.nickname }}</div> -->
                            <div class="tb_date_hour">
                                <span class="mo_th">날짜</span>
                                {{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}
                            </div>
                        </template>
                        <template v-else>
                            <div class="_flex _jc_sb _flex_100">
                                <div class="_flex info_wrap">
                                    <span class="mo_th">분류</span>
                                    <div class="ws_nowrap">{{ item.isSchool === 1 ? "학교주변" : "의심업소" }}</div>
                                    <!-- <span class="divider">｜</span>
                                    <span class="mo_th">작성자</span>
                                    <div class="elips_1 area_detail">{{ item.nickname }}</div> -->
                                </div>
                                <div class="po_ab">
                                    {{ CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true) }}
                                </div>
                            </div>
                        </template>
                    </div>
                </li>
            </ul>
        </div>
        <PageBtn
            v-if="state.list.length !== 0"
            :currentPage="state.page"
            :totalLength="state.totalLength"
            :perPage="state.size"
            @onPaging="handlePageChange"
        ></PageBtn>
    </section>
    <ModalReportBanner :isShow="state.isShowGuideModal" :title="'성매매 의심업소 제보 안내글 수정'" :type="1" @close="closeModal"></ModalReportBanner>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts" config>
    import {
        reactive,
        globalStore,
        onMounted,
        watch,
        router,
        apiService,
        types,
        CommonUtils,
        PageBtn,
        ModalDefault,
        ModalReportBanner,
        ref,
        onBeforeMount,
        userStore,
        getMessageByCode,
    } from "@/BaseComponent";

    export default {
        components: { PageBtn, ModalReportBanner, ModalDefault },
        setup() {
            const global = globalStore();
            const user = userStore();

            const search_type_list = [
                { id: "all", key: null, value: "전체" },
                { id: "1", key: 1, value: "학교주변" },
                { id: "2", key: 0, value: "의심업소" },
            ];
            const state = reactive({
                isShowSearchType: false,
                tab: 0 as number,
                menuContent: "" as string,

                list: [] as Array<any>,
                checkedList: [] as Array<number>,

                searchType: "" as string,
                searchText: "" as string,

                page: 1 as number,
                size: 10 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                detailType: null as number | null,
                detailTxt: "전체" as string,
                isShowBanner: false as boolean,

                hasAuth: false as boolean,

                isShowGuideModal: false as boolean,
                isShowModal: false as boolean,

                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                checkAll: false as boolean,

                isMobile: false,
            });

            onBeforeMount(() => {
                if (
                    user.isLogin() &&
                    (user.userInfo.gubun === 1 ||
                        (user.userInfo.isAdmin && user.roles != null && user.roles.some((item: types.RoleVO) => item.key.indexOf("area") > -1)))
                )
                    state.hasAuth = true;
            });

            onMounted(() => {
                getMenuTitle();
                getList();

                state.isMobile = window.innerWidth < 768;
            });

            watch(
                () => state.checkedList,
                (newVal) => {
                    state.checkAll = newVal.length === state.list.length;
                },
            );

            const openIndex = ref(null);
            const toggle = (index: any) => {
                openIndex.value = openIndex.value === index ? null : index;
            };

            const getMenuTitle = async () => {
                const res = await apiService.report.menuDetail(1);
                if (res.returnCode === 0) {
                    state.menuContent = res.data.headerTitle;
                } else if (res.returnCode === 11) {
                } else if (res.returnCode === 4) {
                } else {
                    console.error(res.description);
                }
            };

            const openModal = () => {
                state.isShowModal = true;
            };

            const openGuideModal = () => {
                state.isShowGuideModal = true;
            };

            const closeModal = () => {
                state.isShowModal = false;
                state.isShowGuideModal = false;
                getMenuTitle();
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    deleteCheckList();
                }
            };

            const toggleAll = () => {
                if (state.checkAll) {
                    state.checkedList = state.list.map((item) => item.idx);
                } else {
                    state.checkedList = [];
                }
            };

            const isDelete = () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const deleteCheckList = async () => {
                const res = await apiService.mypage.reportMultiRemove(state.checkedList.join(","));
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제가 완료되었습니다.";
                    state.isShowModal = true;

                    getList();
                    state.checkedList = [];
                } else if (res.returnCode === 11) {
                } else if (res.returnCode === 4) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "경고";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getList = async () => {
                const param: types.ReqReportList = {
                    detailType: state.detailType,
                    startDate: "",
                    endDate: "",
                    page: state.page,
                    size: state.size,
                    searchType: state.searchType,
                    searchText: state.searchText,
                };
                const res = await apiService.report.list(1, param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else if (res.returnCode === 11) {
                } else if (res.returnCode === 4) {
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const downloadFile = async () => {
                try {
                    const param: types.ReqReportListForExcel = {
                        type: 1,
                        idxList: String(state.checkedList),
                    };

                    let res = await apiService.report.exportExcel(param);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                }
            };

            return {
                state,
                router,
                CommonUtils,
                handlePageChange,
                search_type_list,
                getList,
                global,
                openModal,
                closeModal,
                callBackModal,
                toggle,
                toggleAll,
                openGuideModal,
                downloadFile,
                isDelete,
            };
        },
    };
</script>
